var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"weixin-login"}}),(_vm.errMsg)?_c('span',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.errMsg))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }